var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-default-view"},[_c('CalendarDefault',{attrs:{"content":_vm.calendarContent}}),_c('CalendarLegend',{attrs:{"items":_vm.legendItems,"title":_vm.$t(`message.calendar.legend`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }